import Vue from 'vue';

import './sass/app.scss';

import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/dist/vuetify.min.css';
import StepButtons from './components/StepButtons'

import Vuetify from 'vuetify';
Vue.use(Vuetify, {
  iconfont: 'mdi', // 'md' || 'mdi' || 'fa' || 'fa4'
  theme: {
    primary: '#2C3E50',
    secondary: '#D6803D' 
  }
});


import PrettyInput from 'pretty-checkbox-vue/input';
import PrettyCheck from 'pretty-checkbox-vue/check';
import PrettyRadio from 'pretty-checkbox-vue/radio';
import VOffline from 'v-offline';

Vue.component('p-input', PrettyInput);
Vue.component('p-check', PrettyCheck);
Vue.component('p-radio', PrettyRadio);
Vue.component('v-offline', VOffline);
Vue.component('StepButtons', StepButtons);

import VueFormGenerator from 'vue-form-generator';
import 'vue-form-generator/dist/vfg.css';
Vue.use(VueFormGenerator);

import vueSignature from "vue-signature"
Vue.use(vueSignature)

import VueAxios from 'vue-axios';
import axios from 'axios';
Vue.use(VueAxios, axios);


import Cloudinary from 'cloudinary-vue';
Vue.use(Cloudinary, {
  configuration: {
    cloudName: "presis-utleie"
  }
});

import VueNumberInput from '@chenfengyuan/vue-number-input';

Vue.use(VueNumberInput);

import VueMeta from 'vue-meta';
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

Vue.use(require('vue-pusher'), {
  api_key: process.env.VUE_APP_PUSHER_KEY,
  options: {
    cluster: 'eu',
    encrypted: true
  }
})

import VueQrcodeReader from "vue-qrcode-reader";

Vue.use(VueQrcodeReader);